export default __webpack_public_path__ + "static/media/thsarabunnew_bolditalic-webfont.1f26db5d.ttf";